{
  "dismiss": "Elutasítás"
}
